/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { ServiceGridDto } from './ServiceGridDto';
import {
    ServiceGridDtoFromJSON,
    ServiceGridDtoFromJSONTyped,
    ServiceGridDtoToJSON,
} from './ServiceGridDto';

/**
 * 
 * @export
 * @interface ServiceGridDtoPaginatedResults
 */
export interface ServiceGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ServiceGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ServiceGridDto>}
     * @memberof ServiceGridDtoPaginatedResults
     */
    results?: Array<ServiceGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ServiceGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ServiceGridDtoPaginatedResults interface.
 */
export function instanceOfServiceGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ServiceGridDtoPaginatedResultsFromJSON(json: any): ServiceGridDtoPaginatedResults {
    return ServiceGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ServiceGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ServiceGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ServiceGridDtoPaginatedResultsToJSON(value?: ServiceGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ServiceGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

